module.exports = __webpack_public_path__ + "img/doors.3e33d167.svg";